import React from 'react'
import styled, { keyframes } from 'styled-components'
import { colors, media } from '../styles/vars'
import playIcon from '../static/images/icons/play.png'
import pauseIcon from '../static/images/icons/pause.png'
import waves from '../static/images/backgrounds/wavegifstatic.png'
import wavesGif from '../static/images/backgrounds/wavegif.gif'

const flip360 = keyframes`
0%{
    transform: rotateY(0deg);
    opacity:1;
}
50%{
    opacity:.4;
}
100%{
    transform: rotateY(360deg);
    opacity:1;
}
`
const Container = styled.div`
background-color:rgba(0, 0, 0, .8);
padding:20px;
min-height:490px;
flex-basis:70%;
margin:0 2px;
${
    media.desktop`
    height:450px;
    width:300px;
    min-height:initial;
    margin:0 auto;
    will-change:transform;
    transform-style: preserve-3d;
    `
    }
`
const DynamicContainer = styled(Container) `
${
    media.desktop`
    animation:${props => props.animate ? `${flip360} .8s` : 'none'};
    `
    }
`

const Title = styled.h3`
color:${colors.lightblue};
font-size:3rem;
font-weight:700;
font-family:'Open Sans Hebrew';
margin-bottom:5px;
direction:ltr;
text-align:right;
line-height:1.1;
`
const Paragraph = styled.p`
color:${colors.white};
font-size:2.2rem;
`
const TextContainer = styled.div`
margin: 15px 0;
overflow-wrap:break-word;
`
const PlayerContainer = styled.div`
text-align:center;
margin-bottom:20px;
cursor:pointer;
`
const Waves = styled.div`
display:inline-block;
vertical-align:middle;
width:40%;
padding-bottom:20%;
background-image:url(${waves});
background-repeat:no-repeat;
background-size:contain;
background-position:center;
`
const DynamicWaves = styled(Waves) `
background-image:url(${props => props.active ? wavesGif : waves});
`
const PlayerIconContainer = styled.div`
display:inline-block;
vertical-align:middle;
margin-right:10px;
width:48px;
height:48px;
`
const DynamicImage = styled.img`
display:${props => props.active ? 'block' : 'none'};
`
const PedalDetails = (props) => {
    return (
        <DynamicContainer
            onAnimationEnd={props.onAnimationEnd}
            animate={props.playAnimation}
        >
            <PlayerContainer
                onClick={props.onPlayerClick}
            >
                <DynamicWaves active={props.isAudioPlaying} />
                <PlayerIconContainer>
                    <DynamicImage src={playIcon} alt="" active={!props.isAudioPlaying} />
                    <DynamicImage src={pauseIcon} alt="" active={props.isAudioPlaying} />
                </PlayerIconContainer>
            </PlayerContainer>
            <TextContainer>
                <Title>{props.title}</Title>
                <Paragraph>{props.text}</Paragraph>
            </TextContainer>
        </DynamicContainer>
    )
}

export default PedalDetails;


// WEBPACK FOOTER //
// ./src/components/PedalDetails.jsx